import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import Typography from "material-ui/Typography";
import DialogModal from "../../common/DialogModal";
import Button from "../../Parts/Button";

const styles = () => ({
  paper: {
    maxHeight: "unset",
    background: "#F4F6F9",
    width: "600px",
  },

  contentContainer: {
    padding: '20px 25px',
    margin: 0,
    textAlign: "left",
    whiteSpace: "pre-wrap",
  },

  buttonContainer: {
    display: "inline-flex",
    width: "100%",
    justifyContent: "space-between",
    marginTop: 20,
  },
});

class SelectAddAddressDialog extends React.Component {
  addLetterOrderAddress = () => {
    this.props.toggleDialog()
    this.props.toggleAddAddressDialog()
  }

  addFollowCallAddress = () => {
    this.props.toggleDialog()
    this.props.toggleAddFollowCallAddressDialog()
  }

  render() {
    const { classes, toggleDialog } = this.props;

    return (
      <DialogModal
        classes={{
          paper: classes.paper,
          contentContainer: classes.contentContainer,
        }}
        open={this.props.isOpen}
        maxWidth={false}
        onClose={toggleDialog}
        title={'新規登録するアドレスを選択'}
      >
        <Typography variant="body2">{"フォローコールのみ依頼するアドレスを登録する場合は「フォローコールアドレスを登録」を選択してください。\nそれ以外は「レター送付アドレスを登録」を選択してください。"}
        </Typography>
        <div className={classes.buttonContainer}>
          <Button
            handleClickButton={this.addFollowCallAddress}
            size="large"
            text="フォローコールアドレスを登録"
            style={{ background: '#FFFFFF', color: '#1A65FF', width: 264, padding: '0 20px', border: '1px solid #1A65FF' }}
          ></Button>
          <Button
            handleClickButton={this.addLetterOrderAddress}
            size="large"
            text="レター送付アドレスを登録"
            style={{ width: 264, padding: '0 20px' }}
          ></Button>
        </div>
      </DialogModal>
    );
  }
}

SelectAddAddressDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  isOpen: PropTypes.bool.isRequired,
  toggleDialog: PropTypes.func.isRequired,
  handleClickFollowCall: PropTypes.func.isRequired,
  order: PropTypes.func.isRequired,
  toggleAddAddressDialog: PropTypes.func,
  toggleAddFollowCallAddressDialog: PropTypes.func,
};

export default withStyles(styles)(SelectAddAddressDialog);



// WEBPACK FOOTER //
// ./src/components/AddressBook/dialogs/SelectAddAddressDialog.jsx